// src/components/Inventory/charts/tooltipProps.js
export const getTooltipProps = (darkMode) => ({
  contentStyle: {
    background: darkMode ? "rgba(10,10,10,0.92)" : "rgba(255,255,255,0.96)",
    border: darkMode ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.10)",
    borderRadius: 12,
    color: darkMode ? "rgba(255,255,255,0.92)" : "rgba(0,0,0,0.88)",
    boxShadow: darkMode ? "0 12px 30px rgba(0,0,0,0.55)" : "0 10px 24px rgba(0,0,0,0.12)",
  },
  labelStyle: {
    color: darkMode ? "rgba(255,255,255,0.85)" : "rgba(0,0,0,0.75)",
    fontWeight: 800,
    marginBottom: 4,
  },
  itemStyle: {
    color: darkMode ? "rgba(255,255,255,0.92)" : "rgba(0,0,0,0.88)",
    fontWeight: 700,
  },
  cursor: { fill: darkMode ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)" },
});
